import { GPU } from '@kemtai/utils';
import logger  from '@kemtai/logger';


const isAndroid15 = /Android 15/.test(navigator.userAgent);
const gpu = GPU();
const isProbematicArdenoGPU = /Adreno 7[42]0/.test(gpu)

export function isProbematicAndroid15Ardeno() {
    const result = isProbematicArdenoGPU;
    if (result) {
        logger.event("ProbematicAndroid15ArdenoCombination")
    }
    // logger.event("isProbematicAndroid15Adreno", {
    //     userAgent: navigator.userAgent,
    //     gpu: gpu,
    //     level: "webgl-log",
    //     isAndroid15, 
    //     isProbematicArdenoGPU,
    //     result: result
    // });


    return result;
}